import type { CommonBundle } from './common.ru';

export const commonEn: CommonBundle = {
  cancel: 'Cancel',
  save: 'Save',
  back: 'Back',
  done: 'Done',
  retry: 'Retry',
  loadError: 'Failed to load',
};
